function Help(){
    return(
        <>
              <main class="container">
  <div class="p-4 p-md-5 mb-4 rounded text-body-emphasis mt-3" style={{background:"#c9edec"}}>
    <div class="col-lg-6 px-0">
      <h1 class="display-4 fst-italic">How to Use <span style={{color:"#05b9b3"}}>Grade to SGPA Converter</span></h1>
      <p class="lead my-3">This post will help you to calculate SGPA from Grades using GPA converter.</p>
      <p class="lead mb-0"><a href="#" class="text-body-emphasis fw-bold">Continue reading...</a></p>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-6">
      <div class="row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative card">
        <div class="col p-4 d-flex flex-column position-static">
          {/* <strong class="d-inline-block mb-2 text-primary-emphasis">World</strong> */}
          <h3 class="mb-0">How to Use CGPA calculator</h3>
          {/* <div class="mb-1 text-body-secondary">Nov 12</div> */}
          <p class="card-text mb-auto">This post will help you to calculate CGPA using GPA converter.</p>
          <a href="#" class="icon-link gap-1 icon-link-hover stretched-link">
            Continue reading...
            {/* <svg class="bi"><use xlink:href="#chevron-right"/></svg> */}
          </a>
        </div>
        <div class="col-auto d-none d-lg-block">
          {/* <svg class="bd-placeholder-img" width="200" height="250" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"/><text x="50%" y="50%" fill="#eceeef" dy=".3em">Thumbnail</text></svg> */}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative card">
        <div class="col p-4 d-flex flex-column position-static">
          {/* <strong class="d-inline-block mb-2 text-success-emphasis">Design</strong> */}
          <h3 class="mb-0">How to Use CGPA to Percentage calculator</h3>
          {/* <div class="mb-1 text-body-secondary">Nov 11</div> */}
          <p class="mb-auto">This post will help you to calculate percentage from CGPA using GPA converter.</p>
          <a href="#" class="icon-link gap-1 icon-link-hover stretched-link">
            Continue reading...
            {/* <svg class="bi"><use xlink:href="#chevron-right"/></svg> */}
          </a>
        </div>
        <div class="col-auto d-none d-lg-block">
          {/* <svg class="bd-placeholder-img" width="200" height="250" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"/><text x="50%" y="50%" fill="#eceeef" dy=".3em">Thumbnail</text></svg> */}
        </div>
      </div>
    </div>
  </div>

  </main>
        </>
    )
}

export default Help;